<template>
  <Modal>
    <Modal.Title>Change username</Modal.Title>
    <Modal.Body>
      <div class="flex flex-col gap-2">
        <Input
          v-model="username"
          size="xl"
          label="Username"
          :disabled="loading"
        />
        <UsernameValidation
          :show="showValidation"
          :checking="checkingAvailability"
          :available="isAvailable"
        />
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="!canSave"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Input, Button, useModal } from '@dacr/library'
import type { User } from '@/shared/graphql/legacy/generated'
import UsernameValidation from './UsernameValidation.vue'
import { useChangeUsername } from './useChangeUsername'

const { close } = useModal()

const props = defineProps<{
  user: User
}>()

const {
  username,
  isAvailable,
  checkingAvailability,
  showValidation,
  loading,
  canSave,
  save,
} = useChangeUsername(props.user)

const handleSave = async () => {
  if (await save()) close()
}
</script>
